import { takeEvery, put } from 'redux-saga/effects'
import { ENTERTAINMENT_LIST, SET_ENTERTAINMENT_LIST, SET_TRANSPORT_LIST, TRANSPORT_LIST } from '../constant';
import axios from 'axios';

const baseUrl = process.env.REACT_APP_BASE_URL;

function* getIntertainmentList() {
    let data = yield fetch(baseUrl + "/api/v1/entertainment/list");
    data = yield data.json();
    data = data.data;
    console.log("action is called", data)
    yield put({type: SET_ENTERTAINMENT_LIST, data})
}



function* entertainmentSaga() {
    yield takeEvery(ENTERTAINMENT_LIST, getIntertainmentList)
}

export default entertainmentSaga;